import 数字音容版 from './数字音容.jpg';
import 数字音容Plus from './数字音容Plus.jpg';
import AI念影版 from './AI念影.jpg';
import AI灵犀版 from './AI灵犀.jpg';
import AI拾忆版 from './AI拾忆.jpg';
import AI惜别版 from './AI惜别.jpg';

export const video_type_images = {
  数字音容版: 数字音容版,
  AI念影版: AI念影版,
  AI灵犀版: AI灵犀版,
  AI拾忆版: AI拾忆版,
  AI惜别版: AI惜别版,
  数字音容Plus: 数字音容Plus,
};
